class SellingPlanPicker extends HTMLElement {
  connectedCallback() {
    this._onModeChange = this._onModeChange || this.updateState.bind(this);
    this._onPlanChange = this._onPlanChange || this.onPlanChange.bind(this);
    this.modeInputs = this.querySelectorAll("[data-selling-plan-mode]");
    this.groupRows = this.querySelectorAll("fieldset");
    this.planSelects = this.querySelectorAll("[data-selling-plan-select]");
    this.priceLists = this.findPriceLists();

    this.modeInputs.forEach((input) => {
      input.addEventListener("change", this._onModeChange);
    });
    this.planSelects.forEach((select) => {
      select.addEventListener("change", this._onPlanChange);
    });

    this.updateState();
  }

  disconnectedCallback() {
    if (!this.modeInputs || !this._onModeChange) return;

    this.modeInputs.forEach((input) => {
      input.removeEventListener("change", this._onModeChange);
    });
    this.planSelects.forEach((select) => {
      select.removeEventListener("change", this._onPlanChange);
    });
  }

  updateState() {
    this.groupRows.forEach((groupRow) => {
      const groupRadio = groupRow.querySelector('[data-selling-plan-mode][value^="group-"]');
      const groupOptions = groupRow.querySelector("[data-selling-plan-group-options]");
      const groupSelect = groupRow.querySelector("[data-selling-plan-select]");
      const isActive = Boolean(groupRadio && groupRadio.checked);

      if (groupOptions) groupOptions.hidden = !isActive;
      if (groupSelect) groupSelect.disabled = !isActive;

      if (isActive && groupSelect && !groupSelect.value) {
        const firstValue = groupSelect.dataset.firstValue;
        if (firstValue) groupSelect.value = firstValue;
      }
    });

    this.syncPrice();
    this.syncBenefitBadges();
  }

  findPriceLists() {
    const formId = this.dataset.formId || this.querySelector("[data-selling-plan-select]")?.getAttribute("form");
    if (!formId) return [];

    const priceLists = document.querySelectorAll(
      [
        `product-rerender[observe-form="${formId}"] .product-info__block-item[data-block-type="price"] price-list`,
        `product-rerender[observe-form="${formId}"][id^="product-sticky-add-to-cart"] price-list`,
      ].join(", ")
    );

    return [...priceLists];
  }

  syncPrice() {
    if (!this.priceLists?.length) return;

    const activeSelect = Array.from(this.planSelects).find((select) => !select.disabled);
    const selectedOption = activeSelect?.selectedOptions?.[0];

    const priceValue = selectedOption?.dataset.planPrice || this.dataset.basePrice;
    const compareAtValue = selectedOption?.dataset.planCompareAtPrice || this.dataset.baseCompareAtPrice;
    const formattedPrice = selectedOption?.dataset.planPriceFormatted || this.dataset.basePriceFormatted;
    const formattedCompareAtPrice = selectedOption?.dataset.planCompareAtPriceFormatted || this.dataset.baseCompareAtPriceFormatted;

    const compareNumeric = Number(compareAtValue || 0);
    const priceNumeric = Number(priceValue || 0);
    const showCompareAt = compareNumeric > priceNumeric && formattedCompareAtPrice;

    this.priceLists.forEach((priceList) => {
      const salePrice = priceList.querySelector("sale-price");
      const compareAtPrice = priceList.querySelector("compare-at-price");

      if (salePrice && formattedPrice) {
        const salePriceLabel = salePrice.querySelector(".sr-only")?.outerHTML || "";
        salePrice.innerHTML = `${salePriceLabel}${formattedPrice}`;
      }

      if (!compareAtPrice) return;

      if (showCompareAt) {
        const comparePriceLabel = compareAtPrice.querySelector(".sr-only")?.outerHTML || "";
        compareAtPrice.innerHTML = `${comparePriceLabel}${formattedCompareAtPrice}`;
        compareAtPrice.hidden = false;
      } else {
        compareAtPrice.hidden = true;
      }
    });
  }

  syncBenefitBadges() {
    this.groupRows.forEach((groupRow) => {
      const badge = groupRow.querySelector("[data-selling-plan-benefit]");
      const select = groupRow.querySelector("[data-selling-plan-select]");
      const selectedOption = select?.selectedOptions?.[0];

      if (!badge) return;

      const benefit = Number(selectedOption?.dataset.planBenefit || 0);

      if (benefit > 0) {
        const benefitFormatted = selectedOption?.dataset.planBenefitFormatted;
        badge.hidden = false;
        badge.textContent = benefitFormatted ? `-${benefitFormatted}` : "";
      } else {
        badge.hidden = true;
        badge.textContent = "";
      }
    });
  }

  onPlanChange() {
    this.syncPrice();
    this.syncBenefitBadges();
  }
}

if (!window.customElements.get("selling-plan-picker")) {
  window.customElements.define("selling-plan-picker", SellingPlanPicker);
}
